import { useMatch } from 'react-router';

import { useIsMobileBp } from 'hooks/breakpoints';
import { RunningExperiments, useExperiments } from 'state/experiments';
import type { VariantOptions } from 'state/experiments/types';

export function useExperiment(variantOptions?: VariantOptions): 'control' | 'treatment' {
  const { variant } = useExperiments();
  const isHomePage = useMatch('/');

  const isMobile = useIsMobileBp();

  if (!isMobile || !isHomePage) {
    return 'control';
  }

  if (variant(RunningExperiments.SimplifiedLandingPage, 'treatment', variantOptions)) {
    return 'treatment';
  }

  return 'control';
}
